import { apiClient } from './client';
import { API_CONFIG } from './config';

export type TimeSlot = { openTime: string; closeTime: string };
export type DayHours = { isOpen: boolean; time: TimeSlot[] };
export type WeekHours = Record<number, DayHours>;

export type OperationConfig = {
  interval?: string;
  hours?: WeekHours;
};

export type AboutUsSection = {
  imageUrl?: string;
  imageId?: string;
  title: string;
  content: string;
};

export type ProjectSettingEntity = {
  projectSettingId: string;
  coverImage: string | null;
  logoImage: string | null;
  coverImageFiles: { s3Url: string }[] | null;
  logoImageFiles: { s3Url: string }[] | null;
  motto: string | null;
  welcomeMessage: string | null;
  address: string | null;
  addressLink: string | null;
  contactNo: string | null;
  contactEmail: string | null;
  themeColor: string | null;
  buttonColor: string | null;
  serviceColor: string | null;
  offsiteName: string | null;
  externalName: string | null;
  remarkLabel: string | null;
  defaultLanguage: string | null;
  allowOffsiteBooking: boolean;
  allowExternalBooking: boolean;
  allowCustomerLogin: boolean;
  productSectionEnabled: boolean;
  commissionPercentage: string | null;
  aboutUsEnabled: boolean;
  aboutUsContent: AboutUsSection[] | null;
  operation: {
    offsite?: OperationConfig;
    onsite?: OperationConfig;
  } | null;
  metadata: {
    invoiceNotes?: string;
  } | null;
  [key: string]: unknown;
};

export type UpdateSettingRequest = Partial<ProjectSettingEntity>;

class SettingsApi {
  private ep = API_CONFIG.endpoints.projects;

  get() {
    return apiClient.get<ProjectSettingEntity>(this.ep.setting);
  }

  update(data: UpdateSettingRequest) {
    return apiClient.patch<ProjectSettingEntity>(this.ep.updateSetting, data);
  }
}

export const settingsApi = new SettingsApi();
